export const LEAD_STATUSES = [
  { key: 'paid', label: 'Paid', color: '#10b981', pill: 'bg-green-100 text-green-800' },
  { key: 'unpaid_order', label: 'Order not paid', color: '#3b82f6', pill: 'bg-blue-100 text-blue-800' },
  { key: 'handoff', label: 'Handed to staff', color: '#f59e0b', pill: 'bg-amber-100 text-amber-800' },
  { key: 'no_order', label: 'No order yet', color: '#9ca3af', pill: 'bg-gray-100 text-gray-800' }
]

export const LEAD_STATUS_KEYS = LEAD_STATUSES.map(status => status.key)

export const CHANNEL_REPORTS = {
  form: { title: 'Inquiry form report', name: 'Inquiry form', downloadType: 'website_form_leads' },
  chat: { title: 'Chat widget report', name: 'Chat widget', downloadType: 'website_chat_leads' }
}

const FUNNEL_LABELS = {
  leads: 'Leads',
  orders: 'Orders',
  paid_orders: 'Paid'
}

export const statusFor = key =>
  LEAD_STATUSES.find(status => status.key === key) ?? LEAD_STATUSES[LEAD_STATUSES.length - 1]

export const formatMoney = cents => {
  const dollars = (cents || 0) / 100
  const digits = Number.isInteger(dollars) ? 0 : 2
  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`
}

export const ratio = (current, prior) => {
  if (!prior) return null
  return (current - prior) / prior
}

export const conversionRate = totals => {
  if (!totals?.leads) return null
  return Math.round((totals.paid_leads / totals.leads) * 100)
}

export const funnelSteps = funnel =>
  funnel.map((step, index) => {
    const previous = index > 0 ? funnel[index - 1].count : 0
    return {
      key: step.step,
      label: FUNNEL_LABELS[step.step] ?? step.step,
      count: step.count,
      share: previous ? Math.round((step.count / previous) * 100) : null
    }
  })

export const periodLabel = (iso, grouping) => {
  const text = new Date(`${iso}T00:00:00`).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  return grouping === 'week' ? `Week of ${text}` : text
}

export const chartData = (periods, grouping, statuses = LEAD_STATUS_KEYS) => {
  if (!periods?.length) return null

  return {
    labels: periods.map(period => periodLabel(period.date, grouping)),
    datasets: LEAD_STATUSES.filter(status => statuses.includes(status.key)).map(status => ({
      label: status.label,
      backgroundColor: status.color,
      stack: 'leads',
      data: periods.map(period => period[status.key] || 0)
    }))
  }
}
